var hoverToggle;

//IE console error fix
if (!window.console) {
    var console = {
        log: function () {}
    };
}

/* http://www.elated.com/articles/javascript-and-cookies/ */
function set_cookie ( name, value, exp_y, exp_m, exp_d, path, domain, secure )
{
  var options = {};
  options.path = path;
  options.domain = domain;
  options.secure = secure;
  if (exp_y && exp_m && exp_d) {
    options.expires = new Date(exp_y, exp_m, exp_d);
  }
  jQuery.cookie(name, value, options);
}

function cw_check_disable_loading_buttons($){
  $('.btn.cw_disable_on_click').on('click', function(e){
    var dospace = $('html').hasClass('lt-ie9');
    $(this).addClass("cw_disabled").addClass("cw_loading");
    if($(this).is("a")) {
      var $a = $(this);
      setTimeout(function(){
        // to please jslint...
        var dummy = ['javascript', ':', 'void(0)'].join('');
        $a.attr("href", dummy);
        $a.unbind('click');
        $a.click(function(e2){
          e2.preventDefault();
        });
      },1);
      if(dospace) {
        $a.attr('data-text', $(this).text());
        $a.html(' ');
      }

    } else if($(this).is("button") || $(this).is("input[type=submit]") || $(this).is("input[type=button]") ) {
      var $btn = $(this);
      setTimeout(function(){
        var onclick = $btn.attr("onclick");
        if (typeof onclick !== 'undefined' && onclick !== false) {
          $btn.attr("data-prev-onclick", onclick);
        }
        $btn.attr("onclick", "return false;");
      }, 1);
      if(dospace) {
        if($btn.is("button")) {
          $btn.attr('data-text', $btn.text());
          $btn.html(' ');
        } else {
          $btn.attr('data-text', $btn.attr('value'));
          $btn.attr('value', ' ');
        }
      }
    }

  });
}

function cw_csrf_protection(xhr) {
  var token = jQuery('meta[name="csrf-token"]').attr('content');
  if (token) {
    xhr.setRequestHeader('X-CSRF-Token', token);
  }
}

function updatesAlert($el, inc) {
  var counter = parseInt($el.text()) || 0;
  counter += inc;
  if (counter > 0) {
    $el.addClass('cw-updates_alert--has_updates').text(counter);
  } else {
    $el.removeClass('cw-updates_alert--has_updates').text('0');
  }
}

function cw_open_register_modal($, url) {
  var type = 'ajax';
  if (!url) { return; }
  var open_callback = function(){};
  if($("html").hasClass("lt-ie10")) {
    var qschar = "?";
    if(url.indexOf("?")>7) {
      qschar = "&";
    }
    url += qschar+"load_v2=true";
    if (url.indexOf('http://')>=0) {
      url = url.replace('http://','https://');
    } else {
      url = 'https://'+document.domain.replace(/(veiling|encheres|auktion|auction)\./,'www.')+url;
    }
    type = 'iframe';
    open_callback = function(){
      $(".mfp-content").css({width: '400px', height: '626px'});
    };
  }
  $.magnificPopup.open({
    items: {
      src: url
    },
    type: type,
    callbacks: {
      ajaxContentAdded: function() {
        cw_check_disable_loading_buttons($);
        $('input, textarea').placeholder();
        $('.mfp-container button.mfp-close').each(function(){
          $(this).appendTo($(this).closest('.mfp-container'));
        });
      },
      open: function(){
        open_callback();
      }
    }
  }, 0);
}

function bind_modal_body_links(){
  $(".view_details a").bind( "click", function(event) {
    event.preventDefault();
    var url = $(this).attr("href");
    if ($(this).hasClass('image')) {
      // alert(url);

      $.magnificPopup.close();
      $.magnificPopup.open({
        items: {
          src: url
        },
        type: 'image'
      }, 0);
    }
  });
}

function reset_cookie(cookie_name) {
  jQuery.cookie(cookie_name, '', {expires: -1, path: '/'});
}

function flash_check() {
  var message = jQuery.cookie('message');
  if (!message) {return;}

  message = message.replace(/[+]/g," ");
  var type =  jQuery.cookie('message_type',"notice");
  if (message !== "") {
    document.getElementById("flash_area").innerHTML = '<div class="row" style="margin-bottom: -30px;"><div id="flash" class="notice span16"><p>' + message + '</p></div></div>';
  }
  reset_cookie("message");
  reset_cookie("message_type");
}

function cw_load_socialmedia_async() {
  //facebook
  if( !$('html').hasClass("lt-ie8")) {
    var fb_locale = "nl";
    if ($("body").data("locale")) {
      fb_locale = $("body").data("locale").replace("-", "_").replace("du","de").replace("DU","DE");
    }
    setTimeout(
      function(){
        (function(d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) { return; }
          js = d.createElement(s); js.id = id;
          js.src = "//connect.facebook.net/"+fb_locale+"/all.js#xfbml=1&appId=610120832449695";
          fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
      },300);
  }
  //twitter
  setTimeout(
    function(){
      var dummy = !function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0];if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src="//platform.twitter.com/widgets.js";fjs.parentNode.insertBefore(js,fjs);}}(document,"script","twitter-wjs");
    },300);

  //pinterest
  setTimeout(function (){
    var script = document.createElement("script");
    script.async = true;
    script.src = "//assets.pinterest.com/js/pinit.js";
    var heads = document.getElementsByTagName('head');
    if(heads.length>0) {
      heads[0].appendChild(script);
    }
  },300);
}

function cw_check_login_modal($){
  if((new RegExp("[\\?&]show_login_modal=true")).test(location.href)) {
    var qs = "";
    var lot_id = $('.row.cw_lot_content .lot.detail #lot_id').val();
    var auction_id = $('.cw_auction_content input#auction_id').val();

    if(typeof lot_id != 'undefined') {
      qs = "?lot_id="+encodeURIComponent(lot_id);
    } else if(typeof auction_id != 'undefined') {
      qs = "?auction_id="+encodeURIComponent(auction_id);
    }
    $.magnificPopup.open({
      items: {
        src: '/register_user/show_login_modal' + qs
      },
      type: 'ajax'
    }, 0);
  }
}

/****

  function to show a confirm dialog. the callback must be a function which will
  be called (most of the time) when the dialog is completed.
  If a user cancels dialog by clicking outside of the window it will not be
  called.
  callback arguments is an object : { confirmed: boolean }
  Allows custom text in the buttons of the dialog. This is a tweaked backport of
  v3 `cw_show_confirm_dialog` function.

*/

function cw_show_confirm_custom_btns(title,message,callback,btn_true,btn_false) {
  if(!!btn_true && !!btn_false) {
    $('#cw_modal_confirmdialog_true').text(TRANSLATIONS[btn_true] || "Yes");
    $('#cw_modal_confirmdialog_false').text(TRANSLATIONS[btn_false] || "No");
  }
  cw_show_confirm_dialog(title,message,callback);
}

/****

  function to show a confirm dialog. the callback must be a function which will be called (most of the time) when the dialog is completed.
  If a user cancels dialog by clicking outside of the window it will not be called.
  callback arguments is an object : { confirmed: boolean }

*/
var cw_confirmdialog_eventhandler = null;
function cw_show_confirm_dialog(title,message,callback) {

  if(document.apnToolbarUsed || $('body').hasClass("cw_mobile")) {
    // strip html tags.
    message = message.replace(/<[^>]*>/g, " ").replace(/\n/," ").replace(/\s+/g, " ");

    if(confirm(message)) {
      callback({ confirmed: true });

    } else {
      callback({ confirmed: false });
    }
  } else {
    if (!cw_confirmdialog_eventhandler) {
      cw_confirmdialog_eventhandler = { finished: false, callback: callback };
      $("#cw_modal_confirmdialog").on('click',"#cw_modal_confirmdialog_true",function (e) {
        e.preventDefault();
        $("#cw_modal_confirmdialog").modal("hide");
        if (!cw_confirmdialog_eventhandler.finished) {
          cw_confirmdialog_eventhandler.callback({ confirmed: true });
        }
        cw_confirmdialog_eventhandler = { finished: true, callback: null };
      });
      $("#cw_modal_confirmdialog").on('click',"#cw_modal_confirmdialog_false",function (e) {
        e.preventDefault();
        $("#cw_modal_confirmdialog").modal("hide");
        if (!cw_confirmdialog_eventhandler.finished) {
          cw_confirmdialog_eventhandler.callback({ confirmed: false });
        }
        cw_confirmdialog_eventhandler = { finished: true, callback: null };
      });
    }
    else {
      cw_confirmdialog_eventhandler.finished = false;
      cw_confirmdialog_eventhandler.callback = callback;
    }

    var modal = $("#cw_modal_confirmdialog");
    if (modal.hasClass('modal')) { // V2
      $(".modal_header h3",modal).html(title);
      $(".modal_body",modal).html(message);
    } else { // V3
      modal.addClass('modal').removeClass('mfp-hide');
      $(".cw-modal-header h1",modal).html(title);
      $(".cw-modal-body",modal).html(message);
    }

    modal.modal();
  }



}


/****

  function to show a an alert dialog box.

*/

var cw_alertdialog_eventhandler = null;
var cw_alertdialog_eventhandler_installed = false;

function cw_show_alert_dialog(title,message,callback) {
  if(document.apnToolbarUsed || $('body').hasClass("cw_mobile")) {
    // strip html tags.
    message = message.replace(/<[^>]*>/g, " ").replace(/\n/," ").replace(/\s+/g, " ");
    alert(message);
    callback();

  } else {
    var modal = $("#cw_modal_alertdialog");
    if (modal.hasClass('modal')) { // V2
      $(".modal_header h3",modal).html(title);
      $(".modal_body",modal).html(message);
    } else { // V3
      modal.addClass('modal').removeClass('mfp-hide');
      $(".cw-modal-header h1",modal).html(title);
      $(".cw-modal-body",modal).html(message);
    }

    // override previous eventhandler. or create it for the first time.
    cw_alertdialog_eventhandler = callback;

    // installation of the eventhandler happens only once.
    if (!cw_alertdialog_eventhandler_installed) {
          modal.on('hidden',function () {
            if (cw_alertdialog_eventhandler) { cw_alertdialog_eventhandler(); }
          });
          cw_alertdialog_eventhandler_installed = true;
    }

    modal.modal();
  }

}

function cw_get_current_host() {
  return location.host;
}

function cw_get_current_tld(){
  try {
    var re = /catawiki\.([a-z.]+)/;
    return re.exec(location.href)[1];
  }
  catch(e) {
    throw e;
  }
}

function cw_get_current_domain(){
  try {
    return location.href.match(/https?:\/\/(.*catawiki[^.]*)/)[1];
  }
  catch(e) {
    throw e;
  }
}

function cw_dispatch_mouse_event(event, anchorObj) {
  if (anchorObj.get(0).click) {
    anchorObj.get(0).click();
    return;
  } else if(document.createEvent) {
    try{
      var evt = document.createEvent("MouseEvents");
      evt.initMouseEvent("click", true, true, window,
          0, 0, 0, 0, 0, false, false, false, false, 0, null);
      var allowDefault = anchorObj.dispatchEvent(evt);
      return;
    }
    catch(exc){/* if error continue */}
  }
  location.href = anchorObj.attr("href");
}

function cw_add_data_link_clicks($, selector) {
  $(selector +' a').click(function(e){
    e.stopPropagation();
  });
  $(selector).each(function(){
    var $parent = $(this);
    $parent.css({'cursor': 'pointer'});
    $parent.on('click',function (e) {
      var link = $parent.find($parent.attr("data-link") + ":first");

      cw_dispatch_mouse_event(e, link);
    });
  });

}

/* Function to switch language */
function reload_page_with_host(main_host, auction_host, locale) {
  try {
    if(locale) {
      var alternate = $('link[rel=alternate][hreflang='+locale+']');
      if (alternate && alternate.attr('href')) {
        location.href = alternate.attr('href');
        return;
      }
    }

    // determine slug from full url
    var protocol_domain = location.protocol + "//" + document.domain + "/";
    var full_url = location.href;
    var slug_with_slash = full_url.replace(protocol_domain,"");
    var slug = slug_with_slash.replace("^/","");
    var new_domain, new_host, new_slug, main_old_domain, main_new_domain;

    // determine new domain
    if (location.host.match(/(veiling|encheres|auktion|auction)/)) {
      new_domain = auction_host;
    }
    else {
      new_domain = main_host;
    }
    // also convert subdomains
    if (slug.match(/(veiling(\.[a-z]+)?.catawiki|encheres(\.[a-z]+)?.catawiki|auktion(\.[a-z]+)?.catawiki|auction(\.[a-z]+)?.catawiki)/)) {
      new_host = auction_host.match(/.*(?=\.\w+)/);
      new_slug = slug.replace(/(veiling(\.[a-z]+)?.catawiki|encheres(\.[a-z]+)?.catawiki|auktion(\.[a-z]+)?.catawiki|auction(\.[a-z]+)?.catawiki)/, new_host);
    }
    else {
      new_host = main_host.match(/.*(?=\.\w+)/);
      new_slug = slug.replace(/(\.[a-z]+)?.catawiki/, new_host);
    }

    // also replace possible domain in slug
    main_old_domain = location.host.match(/\.catawiki\.[a-z.]+/);
    main_new_domain = new_domain.match(/\.catawiki\.[a-z.]+/);
    var re = new RegExp(main_old_domain, 'g');
    new_slug = new_slug.replace(re, main_new_domain);

    location.href = location.protocol + "//" + new_domain + "/" + new_slug;
    // alert(location.protocol + "//" + new_domain + "/" + new_slug);
  } catch(e) {
    location.href = main_host;
  }
}

/* Forward ports from application.js */

function cw_save_view_location() {
  set_cookie('_catawiki_view', document.location.href, null, null, null, '/');
}

function save_view_location() {
  cw_save_view_location();
}

/* duplicate function, this is also defined in v3/main.js */
function ga_set_custom_dimension(dimension, value){
  if(value && dimension){
    ga('set', ('dimension'+dimension), value);
    ga('send', 'event', 'Set custom dimension', ('dimension'+dimension), value, {nonInteraction:true});
  }
}

var cwGetSelectedOptionText = function($element) {
  if ($element.length > 0) {
    try { return $($element.get(0).options[$element.get(0).selectedIndex]).text(); }
    catch(err) { return $($element.get(0).options[$element.eq(0).selectedIndex]).text(); }
  }
};

var cwNiceSelects = function() {
  $('div.cw-custom_select').remove();
  $('select.cw-nice_select').each(function(){
    var $_this = $(this);
    var state = false;
    var $custom_select = $('<div/>')
      .addClass('cw-custom_select')
      .text(cwGetSelectedOptionText($_this))
      .append(
        $('<span/>').addClass('cw-custom_select-button')
      );
    $_this
      .css({
        'position': 'absolute',
        'z-index': 1,
        'opacity': 0
      })
      .after($custom_select)
      .on('focus.cwNiceSelects', function(){
        if (!state) {
          state = true;
          $custom_select.addClass('active');
        }
      })
      .on('blur.cwNiceSelects', function(){
        if (state) {
          state = false;
          $custom_select.removeClass('active');
        }
      })
      .on('change.cwNiceSelects', function(){
        $custom_select.text(cwGetSelectedOptionText($_this)).append(
          $('<span/>').addClass('cw-custom_select-button')
        );
      });
  });
};

function ga_set_custom_dimension(dimension, value){
  if(value && dimension){
    dataLayer.push({
      'event': 'ab_cd_push',
      'eventCategory': 'AB testing',
      'eventAction': ('dimension'+dimension),
      'eventLabel': value,
      'cdIndex': dimension,
      'cdValue': value
    });
  }
}

jQuery(document).ready(function($){
 // NOTE: Search autocomplete Temporarely disabled!

  // $('#cw_main_search input').on('keydown', function (e) {
  //   var keycode = e.keyCode;
  //   var $this = $(this);

  //   setTimeout(function(){
  //     var $li_highlight = $('.searchAutocomplete li.hlight'),$li = $('.searchAutocomplete li');
  //     if ((keycode >= 65 && keycode <= 90) ||
  //         (keycode >= 97 && keycode <= 122) ||
  //         (keycode >= 48 && keycode <= 57) || keycode == 8){
  //       var searchField = $this.get(0).value;
  //       //searchField += String.fromCharCode(e.keyCode);

  //       var suggType = $this.attr("suggestion_type");
  //       var output = '';

  //       jQuery.get("/search/solr_suggestions", {
  //         q: searchField,
  //         sugg_type: suggType
  //       }, function (autocomple_result) {
  //         if(autocomple_result && autocomple_result !=""){
  //           $('.searchAutocomplete').show();
  //           output = '<ul class="unstyled">';
  //           for (var i = 0; i < autocomple_result.length; i++) {
  //             var data = autocomple_result[i];
  //             output += '<li><a onclick="jQuery(\'#cw_main_search input\').val(\'' + data.hit + '\');" href="/search?q=' + encodeURIComponent(data.hit) + '">' + data.highlighted_hit + '</a></li>';
  //           };

  //           output += '</ul>';
  //         }else{
  //           $('.searchAutocomplete').hide();
  //           output = '';
  //         }
  //         $('.searchAutocomplete').html(output);

  //       });
  //     } else if (e.keyCode == 40) {
  //       $li_highlight.removeClass('hlight').next().addClass('hlight');
  //       $('#cw_main_search input').val($li_highlight.next().text());
  //       if ($li_highlight.next().length == 0) {
  //         $li.eq(0).addClass('hlight');
  //         $('#cw_main_search input').val($li.eq(0).text());
  //       }
  //     } else if (e.keyCode === 38) {
  //       $li_highlight.removeClass('hlight').prev().addClass('hlight');
  //       $('#cw_main_search input').val($li_highlight.prev().text());
  //       if ($li_highlight.prev().length == 0) {
  //         $li.eq(-1).addClass('hlight');
  //         $('#cw_main_search input').val($li.eq(-1).text());
  //       }
  //     }else if( e.keyCode == 46 ){
  //       $('.searchAutocomplete').hide();
  //       $this.val('');
  //     }
  //   },50);


  // });

  // $( ".searchAutocomplete" ).mouseover(function() {
  //     $('.hlight').removeClass('hlight');
  //   });

  // $(document).bind('click', function(e) {
  //   if(!$(e.target).hasClass('searchAutocomplete')) {
  //     $('.searchAutocomplete').hide();
  //   }
  // })
  //sticky header

  $("html").removeClass("no-js");
  if(/msie/.test(navigator.userAgent.toLowerCase())) {
    $('html').addClass("ie");
  }
  if(/msie 10/.test(navigator.userAgent.toLowerCase())) {
    $('html').addClass("ie10");
  }

  $().UItoTop({
    containerID: 'cw_to_top'
  });

  //$("#cw_my_catawiki, #cw_my_messages").addClass("cw_has_update");
  $('input, textarea').placeholder();

  if(!$("html").hasClass("lt-ie8")) {
    $("a.register_link").click(function(e) { // the containers for all your galleries should have the class gallery
      var url = $(this).attr('data-magnific-popup-link');
      cw_open_register_modal($, url);
      e.preventDefault();
    });
  }

  /** TEMPORARY CACHE FIX FOR REGISTRATION FLOW UPDATE PROCESS **/
  var $old_links = $("#cw_user_navigation ul.cw_not_logged_in li:nth-child(2) a:not([data-magnific-popup-link])");
  if($old_links.length>0) {
    var cw_cached_add_magnific_popup_register_link = function(){
      var domain = document.domain.replace(/^(veiling|auction|encheres|auktion)\./,'www.')      ;
      $old_links.click(function(e){
        cw_open_register_modal($, "http://"+domain+"/accounts/modals/sign_up");
        e.preventDefault();
      });
    };
    if(typeof $.magnificPopup == "undefined") {
      var script = document.createElement("script");
      script.onload = cw_cached_add_magnific_popup_register_link;
      script.src = "/javascripts/v2/jquery.magnific-popup.min.js";
      var h = document.getElementsByTagName('head')[0];
      h.appendChild(script);
    } else {
      cw_cached_add_magnific_popup_register_link();
    }
  }
  /** END TEMPORARY CACHE FIX FOR REGISTRATION FLOW UPDATE PROCESS **/

  // scroll anchor links
  // FIXME: this code attaches scroll to *every* # link, which is really-really
  // bad idea. In order to keep it compatible I've added exclusion class instead
  // of rewriting.
  $('a[href^="#"]:not([data-toggle="tab"])').not('.custom-control').on('click',function (e) {
      e.preventDefault();
      var target = this.hash;
      if(target==="") {
        target = "#top";
      }
      var $target = $(target);
      var new_top = $target.offset().top;
      $('html, body').stop().animate({
        'scrollTop': new_top
      }, 500, function () {
        if (history && history.pushState) {
          history.pushState(null, null, target);
        } else {
          location.hash = target;
        }
        $target.focus();
      });
  });

  cw_add_data_link_clicks($, '*[data-link]');

  $('*[data-cw-toggle]').each(function(){
    var $parent = $(this);
    $parent.on('click',function (e) {
      clearTimeout(hoverToggle);
      $('.cw_dropdown_menu').hide(); //hide others
      var $menu = $parent.next($parent.attr("data-cw-toggle") + ":first");

      if(typeof $menu.get(0) == "undefined") {
        $menu = $parent.parents(".row").find($parent.attr("data-cw-toggle") + ":first");
      }

      $menu.fadeToggle(200);
      e.stopPropagation();
      $menu.click(function(e2){
        e2.stopPropagation();
      });
      $(document).click(function(){
        $menu.hide();
      });
    });
  });

  $('*[data-cw-toggle-list]').each(function(){
    var $parent = $(this);
    $parent.on('click',function (e) {
      var $menu = $parent.parents("ul:first").find($parent.attr("data-cw-toggle-list"));
      var current_text = $parent.text();
      $parent.text($parent.attr("data-cw-toggle-less-text"));
      $parent.attr("data-cw-toggle-less-text", current_text);
      $menu.slideToggle("fast");
      e.stopPropagation();
      $menu.click(function(e2){
        e2.stopPropagation();
      });
    });
  });

  $('*[data-cw-hover-toggle]').each(function(){
    var $parent = $(this);
    $parent.hover(function (e) {
      clearTimeout(hoverToggle);

      $('.cw_dropdown_menu').hide(); //hide others
      var $menu = $parent.next($parent.attr("data-cw-hover-toggle") + ":first");
      $menu.hide();
      hoverToggle = setTimeout(function(){
        $menu.fadeIn(200);
      },400);

      e.stopPropagation();
      $menu.click(function(e2){
        e2.stopPropagation();
      });
      $(document).click(function(){
        $menu.hide();
      });
      $menu.hover(function(){
        clearTimeout(hoverToggle);
      },
      function(){
        clearTimeout(hoverToggle);
        hoverToggle = setTimeout(function(){
          $menu.hide();
        }, 400);
      }
      );
    },
    function(e) {
      clearTimeout(hoverToggle);
      var $menu = $parent.next($parent.attr("data-cw-hover-toggle") + ":first");
      hoverToggle = setTimeout(function(){
        $menu.hide();
      }, 400);


    }
    );
  });

  $("*[data-cw-tooltip=true]").tooltip({
    'placement': 'top'
  });

  //init gallery
  $("*[data-cw-gallery=true]").each(function() { // the containers for all your galleries should have the class gallery
    var delegate = $(this).data("cw-delegate");
    if(!delegate) {
      delegate = "a";
    }
    $(this).magnificPopup({
        delegate: delegate, // the container for each your gallery items
        type: 'image',
        gallery:{enabled:true,

          tPrev: TRANSLATIONS.gallery_previous_left_key, // title for left button
          tNext: TRANSLATIONS.gallery_next_right_key, // title for right button
          tCounter: '<span class="mfp-counter">'+TRANSLATIONS.gallery_x_of_total+'</span>' // markup of counter
        }
    });
  });

  $("*[data-cw-inline-modal=true]").each(function() {
    $(this).magnificPopup({
      type: 'inline',
      callbacks: {
        open: function() {
          // button needs to be moved out of the content!
          $('.mfp-container button.mfp-close').each(function(){
            $(this).appendTo($(this).closest('.mfp-container'));
          });
        }
      }
    });
  });

  $("*[data-cw-ajax-modal=true]").each(function() { // the containers for all your galleries should have the class gallery
    var scrollTo=$(this).data('cw-ajax-modal-scroll-to');
    var is_wide = $(this).data('cw-ajax-modal-wide') || false;
    var is_medium = $(this).data('cw-ajax-modal-medium') || false;
    $(this).magnificPopup({
      type: 'ajax',
      mainClass: (is_wide) ? 'cw-popup-wide' : ((is_medium) ? 'cw-popup-medium' : 'cw-popup-normal'),
      callbacks: {
        parseAjax: function(mfpResponse) {
          mfpResponse.data = $(mfpResponse.data);
          $(mfpResponse.data).find('#managed_content table').attr('border', '0').addClass('table-striped');
          $(mfpResponse.data).find('a.replace_popup').each(function(i) {
            $(this).each(function() {
              $(this).magnificPopup({
                type: 'ajax',
                callbacks: {
                  parseAjax: function(mfpResponse) {
                    mfpResponse.data = $(mfpResponse.data);
                    $(mfpResponse.data).find('#managed_content table').attr('border', '0').addClass('table-striped');
                  }
                }
              });
            });
          });
        },
        ajaxContentAdded: function() {
          cw_check_disable_loading_buttons($);
          $('input, textarea').placeholder();
          // button needs to be moved out of the content!
          $('.mfp-container button.mfp-close').each(function(){
            $(this).appendTo($(this).closest('.mfp-container'));
          });
          if (scrollTo) {
            var el = document.getElementById(scrollTo);
            if (el) {
              el.scrollIntoView();
            }
          }
        }
      }
    });
  });

  $("a[data-cw-iframe-modal=true]").magnificPopup({
    type: 'iframe',
    callbacks: {
      open: function(){
        if($('#cw_login_bid_modal').is(':visible')) {
          $('#cw_login_bid_modal').css({  opacity:0.2});
        }
      },
      close: function(){
        if($('#cw_login_bid_modal').is(':visible')) {
          $('#cw_login_bid_modal').css({  opacity:1});
        }
      }
    }
  });

  $('.cw_auction_pages #lot_items').magnificPopup({
    delegate: 'a',
    type: 'ajax',
    gallery: {
      enabled: true
    },
    callbacks: {
      ajaxContentAdded: function(item){
        bind_modal_body_links();
      }
    }
  });

  $("*[data-cw-video-modal=true]").each(function() { // the containers for all your galleries should have the class gallery
    $(this).magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: true,
      fixedContentPos: true
    });
  });

  $('#search_lots_query').on('keyup change', function(e) {
    $('a#add_search_alert').toggle($(this).val().length > 1);
  }).trigger('change');

  $('a#add_search_alert').on('click', function(e) {
    e.preventDefault();
    $('input#create_alert_query').val($('input#search_lots_query').val());
    $('form#create_search_alert').submit();
  });

  //set login class on body
  var user_name = $.cookie('user_name');
  if (!user_name || typeof user_name !="string") {
    $('body').removeClass('cw_logged_in').addClass('cw_not_logged_in');
    user_name = null;
    if($('body').hasClass("cw_auction_pages") && typeof Modernizr!="undefined" && Modernizr.sticky_header) {
      $(window).trigger('scroll');
    }
  } else {
    $('body').removeClass('cw_not_logged_in').addClass('cw_logged_in');
    $('#user_user_name').text(user_name);
    var username_element = $('<span class="cw-my_catawiki-username"></span>').text(user_name);
    $('#cw_my_catawiki span:not(.cw-updates_alert)').addClass('cw-my_catawiki-label').before(username_element).parent().addClass('cw-has_username');
  }

  //beautify legacy polaroid divs
  var sold_for_title;
  switch ($("body").data("lang")) {
    case 'fr': sold_for_title = "Vendu pour"; break;
    case 'en': sold_for_title = "Sold for"; break;
    case 'du': sold_for_title = ''; break;
    default: sold_for_title = "Opbrengst"; break;
  }
  $(".polaroid_gallery_widget").addClass("row").addClass("cw_lists_catalog");
  $(".polaroid_gallery_widget img").each(function(){
    var $img = $(this);
    var spanWidth = "2";
    if (typeof $img.attr("spanwidth") != "undefined") {
      spanWidth = $img.attr("spanwidth");
    }
    $img.wrap('<div class=\"span'+spanWidth+'\" />');
    $img.wrap('<article />');
    if(typeof $img.attr("data-sold-for") != "undefined" ) {
      $("<header><small class='gray'>"+sold_for_title+" &euro; " + $img.attr("data-sold-for") + "</span></header>").insertAfter($img);
    }
  });

  if (!disable_marketing_cookies_for_user()){
    cw_load_socialmedia_async();
  }
  cw_check_login_modal($);
  flash_check();

  //Set focus
  var register_form = $('#register_form');
  var fieldWithErrors = $('.fieldWithErrors');
  if(register_form.length){
    if(fieldWithErrors.length){
      fieldWithErrors.first().find('input').focus();
    }else{
      $('#user_master_address_attributes_first_name').focus();
    }
  }

  cw_check_disable_loading_buttons($);

  var faq = function() {
    $('.faq-list .faq-item').each(function(){
      var $self = $(this);
      $self.addClass('closed').find('.faq-question').wrapInner(
        $('<a/>').attr('href', '#').on('click', function(event){
          if (event.preventDefault) {
            event.preventDefault();
          }
          else {
            event.returnValue = false;
          }
          $self.toggleClass('closed');
        }));
    });
  };
  faq();

  cwNiceSelects();
  $('.charity-campaign-form #add-element').click(function(){
    var e = $('.charity-field').last();
    var tag = e.get(0).tagName.toLowerCase();
    e.after(
      $('<'+tag+' class="charity-field">'+'</'+tag+'>').append(e.html().replace(/\d+(?=\_)|\d+(?=\])/g, function(match) {return parseInt(match)+1;}))
    );
  });

  $(".lang-selector a:first").tab("show");
});
